@if (!disableFilterblock) {
  <div class="filterblock data-table-filter">
    <mat-form-field class="search-input-field">
      <input matInput placeholder="Suchen" [formControl]="searchCtrl" />
      <mat-icon matSuffix (click)="searchCtrl.setValue(null)">{{
        (searchCtrl.valueChanges | async) ? 'clear' : 'search'
      }}</mat-icon>
    </mat-form-field>
    <ng-content></ng-content>
  </div>
}

<div class="table-container">
  <table
    mat-table
    matSort
    [multiTemplateDataRows]="enableExpandableRows"
    [matSortActive]="matSortActive"
    [matSortDirection]="matSortDirection"
  >
    @for (column of columnConfig; track column) {
      <ng-container
        [matColumnDef]="
          column.nestedName && column.useNestedName
            ? (column.refName | getNestedName: column.nestedName)
            : column.refName
        "
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [disabled]="column.disableSort ?? false"
        >
          {{ column.name }}
        </th>
        <td mat-cell *matCellDef="let row" (click)="entityClicked(row)">
          @switch (column.type) {
            @default {
              {{
                column.nestedName
                  ? (row
                    | getNestedObject
                      : column.refName
                      : column.nestedName
                      : column?.fallback)
                  : (row[column.refName] ?? column?.fallback)
              }}{{ column.suffix }}
            }
            @case ('image') {
              <img
                [src]="
                  column.nestedName
                    ? (row
                      | getNestedObject: column.refName : column.nestedName)
                    : row[column.refName]
                "
              />
            }
            @case ('date') {
              {{
                (column.nestedName
                  ? (row | getNestedObject: column.refName : column.nestedName)
                  : row[column.refName]
                ) | date: column.dateFormat
              }}
            }
            @case ('currency') {
              {{
                (column.nestedName
                  ? (row
                    | getNestedObject
                      : column.refName
                      : column.nestedName
                      : column?.fallback)
                  : (row[column.refName] ?? column?.fallback)
                ) | currency: 'EUR' : 'symbol-narrow'
              }}{{ column.suffix }}
            }
            @case ('user') {
              {{
                (column.nestedName
                  ? (row | getNestedObject: column.refName : column.nestedName)
                  : row[column.refName]
                ) | getUserById
              }}
            }
            @case ('textToColor') {
              <div
                class="color-container"
                [class]="
                  'color-' +
                  (column.nestedName
                    ? (row
                      | getNestedObject: column.refName : column.nestedName)
                    : row[column.refName])
                "
              >
                <div class="color-dot"></div>
                <mat-icon class="error-icon">error_outline</mat-icon>
                <mat-icon class="sold-out-icon">block</mat-icon>
              </div>
            }
            @case ('boolean') {
              {{
                (
                  column.nestedName
                    ? (row
                      | getNestedObject: column.refName : column.nestedName)
                    : row[column.refName]
                )
                  ? column.trueText
                  : column.falseText
              }}
            }
            @case ('longtext') {
              <div class="text-wrapper">
                {{
                  column.nestedName
                    ? (row
                      | getNestedObject
                        : column.refName
                        : column.nestedName
                        : column?.fallback)
                    : (row[column.refName] ?? column?.fallback)
                }}{{ column.suffix }}
              </div>
            }
          }
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          (click)="toggleExpand(element); $event.stopPropagation()"
        >
          @if (!expandedElements.includes(element)) {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
          @if (expandedElements.includes(element)) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          }
        </button>
      </td>
    </ng-container>

    @if (enableSelection) {
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          {{ selectionHeaderText }}
          @if (hasMasterCheckbox) {
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [class.master-checkbox-margin]="selectionHeaderText.length > 0"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          }
        </th>
        <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="buyStock" [formGroup]="buyStockForm">
      <th mat-header-cell *matHeaderCellDef>In den Warenkorb</th>
      <td mat-cell *matCellDef="let row; index as i">
        <ng-container [formGroupName]="row.id">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Anzahl</mat-label>
            <input
              matInput
              type="number"
              class="buy-stock-input"
              (keydown.enter)="buyStocks()"
              min="0"
              formControlName="amount"
              (focusout)="
                changeStockInputToNextIntervalStep(
                  row.article.samplingStep,
                  row.id
                )
              "
              [max]="row.actualStock"
              [step]="row.article.samplingStep"
            />
          </mat-form-field>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyStockInTrunk" [formGroup]="buyStockForm">
      <th mat-header-cell *matHeaderCellDef>Zur Entnahme hinzufügen</th>
      <td mat-cell *matCellDef="let row; index as i">
        <ng-container [formGroupName]="row.id">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Anzahl</mat-label>
            <input
              matInput
              type="number"
              class="buy-stock-input"
              (keydown.enter)="buyStocks(true); $event.stopPropagation()"
              min="0"
              formControlName="amount"
              (focusout)="
                changeStockInputToNextIntervalStep(
                  row.article.samplingStep,
                  row.id
                )
              "
              [max]="row.actualStock"
              [step]="row.article.samplingStep"
            />
          </mat-form-field>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="bookings" [formGroup]="bookingsForm">
      <th mat-header-cell *matHeaderCellDef>Buchung</th>
      <td mat-cell *matCellDef="let row; index as i">
        <div class="booking-input-container" [formGroupName]="row.id">
          @if ((bookingType | async) === BookingTypeEnum.MOVE) {
            <mat-form-field appearance="outline">
              <mat-label>Empfangender Lagerort</mat-label>
              <mat-select formControlName="receivingStorageLocation">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="storageLocationFilterCtrl"
                  ></ngx-mat-select-search>
                </mat-option>
                @for (
                  storageLocation of (filteredStorageLocations | async) ?? [];
                  track storageLocation
                ) {
                  <mat-option [value]="storageLocation.id">
                    {{ storageLocation.label }} -
                    {{ storageLocation.address.street }},
                    {{
                      storageLocation.address.zip +
                        ' ' +
                        storageLocation.address.city
                    }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field appearance="outline">
            <mat-label>Anzahl</mat-label>
            <input
              matInput
              type="number"
              class="buy-stock-input"
              (keydown.enter)="bookStock()"
              min="0"
              formControlName="amount"
              [max]="
                (bookingType | async) !== BookingTypeEnum.ADD
                  ? row.actualStock
                  : 99999
              "
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Notiz</mat-label>
            <input matInput class="buy-stock-input" formControlName="note" />
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="takeFromTrunk">
      <th mat-header-cell *matHeaderCellDef>Entnehmen</th>
      <td mat-cell *matCellDef="let row; index as i">
        @if (!disableEditing) {
          <div class="take-from-trunk-container">
            <mat-form-field appearance="outline">
              <mat-label>Anzahl</mat-label>
              <input
                matInput
                type="number"
                class="buy-stock-input"
                (keydown.enter)="takeFromTrunk()"
                (focusout)="
                  changeTakeStockInputToNextIntervalStep(
                    $event,
                    i,
                    row.storageLocationArticle.article.samplingStep,
                    row.withdrawnStock * -1,
                    row.availableStock
                  )
                "
                [min]="row.withdrawnStock * -1"
                [max]="row.availableStock"
                [step]="row.storageLocationArticle.article.samplingStep"
                [(ngModel)]="takeStockInputs.value[i]"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Kommentar</mat-label>
              <input
                matInput
                type="text"
                class="buy-stock-input"
                (keydown.enter)="takeFromTrunk()"
                [(ngModel)]="takeStockNotes.value[i]"
              />
            </mat-form-field>
          </div>
        } @else {
          Bearbeitung nicht mehr möglich
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="deliveryActions">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let row">
        <div class="action-buttons-container">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (!disableEditing) {
              <button
                mat-menu-item
                (click)="duplicateEntityClick.emit(row)"
                class="duplicate-button"
              >
                Eintrag duplizieren
                <mat-icon>content_copy</mat-icon>
              </button>
              <button
                mat-menu-item
                (click)="deleteEntityClick.emit(row)"
                class="delete-button"
              >
                Eintrag löschen
                <mat-icon>delete</mat-icon>
              </button>
            } @else {
              <button mat-menu-item>Bearbeitung nicht mehr möglich</button>
            }
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="importAction">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let row">
        <div class="action-buttons-container">
          <button
            mat-stroked-button
            color="primary"
            (click)="entityActionClick.emit(row)"
          >
            Speichern
            <mat-icon>save</mat-icon>
          </button>

          <button
            mat-stroked-button
            color="warn"
            (click)="deleteEntityClick.emit(row)"
          >
            Entfernen
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="deleteAction">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let row">
        <div class="action-buttons-container">
          <button
            mat-stroked-button
            color="warn"
            (click)="deleteEntityClick.emit(row)"
          >
            Entfernen
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="restoreAction">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let row">
        <div class="action-buttons-container">
          <button mat-stroked-button (click)="restoreEntityClick.emit(row)">
            Wiederherstellen
            <mat-icon>restore</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyShortcut">
      <th mat-header-cell *matHeaderCellDef>In den Warenkorb</th>
      <td mat-cell *matCellDef="let row">
        <div class="action-buttons-container">
          <button
            mat-stroked-button
            color="primary"
            (click)="entityActionClick.emit(row)"
            class="add-to-cart-btn"
          >
            In den Warenkorb
            <mat-icon>shopping_cart</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDeliveries">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        class="expand-detail-cell"
      >
        <div
          class="expand-detail-content"
          [class.expanded]="expandedElements.includes(element)"
          [@detailExpand]="
            expandedElements.includes(element) ? 'expanded' : 'collapsed'
          "
        >
          <table mat-table [dataSource]="element.articles">
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>Artikel</th>
              <td mat-cell *matCellDef="let element">
                {{ element.mainArticle.title }}
              </td>
            </ng-container>

            <ng-container matColumnDef="count">
              <th mat-header-cell *matHeaderCellDef>Anzahl</th>
              <td mat-cell *matCellDef="let element">{{ element.count }}</td>
            </ng-container>

            <ng-container matColumnDef="vendorArticleNumber">
              <th mat-header-cell *matHeaderCellDef>
                Lieferanten-Artikelnummer
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.vendorArticle.vendorArticleNumber }}
              </td>
            </ng-container>

            <ng-container matColumnDef="singlePrice">
              <th mat-header-cell *matHeaderCellDef>Einzelpreis</th>
              <td mat-cell *matCellDef="let element">
                {{ element.price | currency: 'EUR' : 'symbol-narrow' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="totalPrice">
              <th mat-header-cell *matHeaderCellDef>Gesamtpreis</th>
              <td mat-cell *matCellDef="let element">
                {{ element.totalPrice | currency: 'EUR' : 'symbol-narrow' }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="[
                'title',
                'count',
                'vendorArticleNumber',
                'singlePrice',
                'totalPrice',
              ]"
            ></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: [
                  'title',
                  'count',
                  'vendorArticleNumber',
                  'singlePrice',
                  'totalPrice',
                ]
              "
            ></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell no-data-cell" [colSpan]="5">
                Keine Artikel vorhanden
              </td>
            </tr>
          </table>

          <button
            mat-flat-button
            color="primary"
            (click)="entityActionClick.emit(element)"
          >
            Volle Ansicht
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedTrunks">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        class="expand-detail-cell"
      >
        <div
          class="expand-detail-content"
          [class.expanded]="expandedElements.includes(element)"
          [@detailExpand]="
            expandedElements.includes(element) ? 'expanded' : 'collapsed'
          "
        >
          <table mat-table [dataSource]="element.articles">
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef>Artikel</th>
              <td mat-cell *matCellDef="let element">
                {{ element.storageLocationArticle.article.title }}
              </td>
            </ng-container>

            <ng-container matColumnDef="withdrawnStock">
              <th mat-header-cell *matHeaderCellDef>Reservierte Menge</th>
              <td mat-cell *matCellDef="let element">
                {{ element.withdrawnStock }}
              </td>
            </ng-container>

            <ng-container matColumnDef="usedStock">
              <th mat-header-cell *matHeaderCellDef>Entnommene Menge</th>
              <td mat-cell *matCellDef="let element">
                {{ element.usedStock }}
              </td>
            </ng-container>

            <ng-container matColumnDef="note">
              <th mat-header-cell *matHeaderCellDef>Notiz</th>
              <td mat-cell *matCellDef="let element">{{ element.note }}</td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="[
                'title',
                'withdrawnStock',
                'usedStock',
                'note',
              ]"
            ></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: ['title', 'withdrawnStock', 'usedStock', 'note']
              "
            ></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell no-data-cell" [colSpan]="4">
                Keine Artikel vorhanden
              </td>
            </tr>
          </table>

          <mat-form-field appearance="fill">
            <mat-label>Notiz</mat-label>
            <textarea matInput disabled [value]="element.note"></textarea>
          </mat-form-field>

          <button
            mat-flat-button
            color="primary"
            (click)="entityActionClick.emit(element)"
          >
            Volle Ansicht
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns; index as i"
      (click)="toggleExpand(row)"
      [class.expanded-rows-activated]="enableExpandableRows"
      class="table-row"
    ></tr>

    @if (enableExpandableRows) {
      <tr
        mat-row
        *matRowDef="let row; columns: expandedColumns"
        class="expand-detail-row"
      ></tr>
    }

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [colSpan]="displayedColumns.length">
        {{ noDataText }}
      </td>
    </tr>
  </table>

  <mat-toolbar [class.hidden]="disablePagination">
    <mat-toolbar-row>
      @if (
        !disableNewButton &&
        (authService.isAdmin() || authService.isPurchasing())
      ) {
        <button
          mat-flat-button
          title="Neu erstellen"
          color="primary"
          (click)="new()"
        >
          {{ newButtonText }}
          <mat-icon>add</mat-icon>
        </button>
      }

      <div class="spacer"></div>

      <mat-paginator
        #paginator
        [length]="total | async"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[1, 25, 50, 100, 250]"
        class="mat-paginator-sticky"
      >
      </mat-paginator>
    </mat-toolbar-row>
  </mat-toolbar>

  @if (displayedColumns.includes('buyStock')) {
    <div class="form-action-row">
      <button
        mat-flat-button
        color="primary"
        (click)="buyStocks()"
        class="save-btn"
      >
        In den Warenkorb
        <mat-icon>shopping_cart</mat-icon>
      </button>
    </div>
  }

  @if (displayedColumns.includes('buyStockInTrunk')) {
    <div class="form-action-row">
      <button
        mat-flat-button
        color="primary"
        (click)="buyStocks(true)"
        class="save-btn"
      >
        Zur Entnahme hinzufügen
        <mat-icon>add_shopping_cart</mat-icon>
      </button>
    </div>
  }

  @if (displayedColumns.includes('bookings')) {
    <div class="form-action-row">
      <button
        mat-flat-button
        color="primary"
        (click)="bookStock()"
        class="save-btn"
        [disabled]="!hasBookingInputs() || bookingsForm.invalid || completed"
      >
        Lagerbuchung {{ completed ? 'durchgeführt' : 'durchführen' }}
        <mat-icon>{{ completed ? 'done_all' : 'check' }}</mat-icon>
      </button>
    </div>
  }

  @if (enableExpandableRows) {
    <div class="form-action-row">
      <button
        mat-flat-button
        color="primary"
        (click)="toggleAllExpanded()"
        class="save-btn"
      >
        Alle {{ allRowsExpanded ? 'einklappen' : 'ausklappen' }}
        <mat-icon>{{
          allRowsExpanded ? 'expand_less' : 'expand_more'
        }}</mat-icon>
      </button>
    </div>
  }

  @if (displayedColumns.includes('takeFromTrunk')) {
    <div class="form-action-row">
      <button
        mat-stroked-button
        (click)="closeTrunk()"
        class="close-trunk-btn"
        [disabled]="disableEditing"
      >
        Entnahme {{ disableEditing ? 'bereits geschlossen' : 'schließen' }}
        <mat-icon>{{ disableEditing ? 'key_off' : 'key' }}</mat-icon>
      </button>
      <button
        mat-stroked-button
        (click)="addArticleToTrunk.emit()"
        class="add-article-to-trunk-btn"
        [disabled]="disableEditing"
      >
        Fehlenden Artikel hinzufügen
        <mat-icon>add_shopping_cart</mat-icon>
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="takeAllFromTrunk()"
        class="save-btn"
        [disabled]="disableEditing"
      >
        Alle entnehmen
        <mat-icon>keyboard_double_arrow_up</mat-icon>
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="takeFromTrunk()"
        [disabled]="disableEditing"
      >
        Abbuchen
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </div>
  }
</div>
